import styled from 'styled-components'

export const MaximumResultsContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
  max-width: 1170px;

  .card-description {
    max-width: 100%;
  }

  > section {
    padding: 0;
    > div {
      margin: 0;
      gap: 32px;
      justify-content: center;
      p {
        font-size: 20px;
        line-height: 30px;
      }
    }
  }

  @media (max-width: 1180px) {
    padding: 0 16px;
  }
  @media (max-width: 500px) {
    gap: 32px;
  }
`
